import React,{Component} from 'react';
import AuthConnector from "../../containers/auth_container";
import {Button, Form, Grid, Image, Popup, Segment,Message} from "semantic-ui-react";
import * as logo from "../../assets/hinchlogosolid.png";
import {getParams} from "../../utils/get_url_params";
import validatePasswordStrength from "../../utils/password_validation";
import {changeForgottenPassword} from "../../data/user_api";

class ResetPassword extends Component {

    constructor(props){
        super(props);
        this.state ={
            headers:getParams(window.location.href),
            passwordMatch:undefined
        }
    }

    validatePassword = (password) => {
        this.setState({
            pswdLength:validatePasswordStrength.charLength(password),
            pswdLC:validatePasswordStrength.lowercase(password),
            pswdUC:validatePasswordStrength.uppercase(password),
            pswdSym:validatePasswordStrength.special(password),
            pswdNum:validatePasswordStrength.hasNumber(password),
        });
    };

    handleSubmit = (e) => {
        e.preventDefault();
        if(!this.state.passwordMatch){
            return;
        }
        const formData = new FormData(e.target);
        changeForgottenPassword(formData,this.state.headers).then((response) => {
            if(response.success){
                this.setState({resetSuccess:true});
                setTimeout(()=>{this.props.history.push('/signin')},5000)
            }
        }).catch((e)=>{
            this.setState({resetSuccess:false});
        })
    };

    render(){
        return (<div className="login-form">
            <Grid textAlign='center' style={{height: '100%'}} verticalAlign='middle'>
                <Grid.Column style={{maxWidth: 450}}>
                     <Image src={logo} size='medium' centered className="signin-logo"/>
                    {!this.state.resetSuccess ? <Form onSubmit={this.handleSubmit}>
                        <Segment>
                            <Popup trigger={
                                <Form.Input fluid icon='lock' iconPosition='left'
                                            placeholder='Password'
                                            type='password' name="password" pattern="(?=.*[a-z])(?=.*[A-Z])(?=.*[\W])(?=.*\d).{6,}"
                                            onChange={(e) => {this.validatePassword(e.target.value); this.setState({password:e.target.value})}}
                                            required/>}
                                   content={<Segment>
                                       <p className={this.state.pswdLength?"info-success":"info-negative"}>Password must be 6 chars or more</p>
                                       <p className={this.state.pswdLC?"info-success":"info-negative"}>Must have atleast 1 lowercase</p>
                                       <p className={this.state.pswdUC?"info-success":"info-negative"}>Must have atleast 1 uppercase</p>
                                       <p className={this.state.pswdSym?"info-success":"info-negative"}>Must have atleast 1 special character</p>
                                       <p className={this.state.pswdNum?"info-success":"info-negative"}>Must have atleast 1 Number</p>
                                   </Segment>}
                                   on="focus"
                                   position="right center"
                                   wide
                                   hideOnScroll
                            />
                            {this.state.passwordMatch === false && <p style={{textAlign:'right',color:'red'}}>Password doesn't match</p>}
                            <Form.Input fluid icon='lock' iconPosition='left' placeholder='Re-Enter NewPassword'
                                        type='password'  name="password_confirmation" id="password_confirmation"
                                        required
                                        onChange={(e) => {this.setState({passwordMatch:(this.state.password === e.target.value)})}}
                            />
                            <Button primary fluid size='large'>Change Password</Button>
                        </Segment>
                    </Form>:<div>
                        <Message size='mini' positive>
                            <Message.Header>Password reset Successful!</Message.Header>
                            <p>You'll now be Redirected to Login Page or you can go to login page by clicking on below Button</p>
                        </Message>
                        <Button fluid content="Login Now" onClick={() => {this.props.history.push('/signin')}} primary />
                    </div>}
                </Grid.Column>
            </Grid>
            </div>
                    );
    }
}
export default AuthConnector(ResetPassword);


// WEBPACK FOOTER //
// ./src/views/auth/reset_password.js